export const Outils = {
    data() {
        return {
            applis : [
            {
                slug : 'sogest',
                title : 'SO GEST',
                desc : 'Gestion du compte professionnel et administration.',
                url : 'https://admin.sopress.net/sogest'
            },
            {
                slug : 'reunions-sopress',
                title : 'Salles de réunion',
                desc : 'Plannings et réservations des salles de réunion.',
                url : 'https://reunions.sopress.net'
            },
            {
                slug : 'tools',
                title : 'Fiches des magazines',
                desc : 'Sommaires et ressources des parutions du groupe',
                url : 'https://tools.sopress.net'
            }
            ]            
        }
    },
    mounted() {},
    methods: {
        logOut() {
            this.$store.commit('setJwt', false);
        }
    },
    computed: {
        appliCourante() {
            for(const key in this.applis) {
                const appli = this.applis[key];
                if(appli.slug == this.$route.query.appli) {
                    if(this.$route.query.back)  {
                        appli.url = this.$route.query.back;
                    }
                    return appli;
                }               
            }
            return false;
        },
        isConnected() {
            if (!this.$store.state.jwt) {
                return false;
            }
            return true;
        }
    }
}